import { createSlice } from '@reduxjs/toolkit';
import { HTTP_GETTYPE, STATUS_API } from 'src/app/constant/config';
import AxiosAdapter from './AxiosAdapter';
import { MESSAGE } from 'src/app/constant/message';

export const getListServicePackages = AxiosAdapter.GetHttp(
  'servicePackageSlice/getListServicePackages',
  '/service_package',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const createServicePackage = AxiosAdapter.HttpPost(
    'vehicleTypeSlice/createVehicleType',
    '/service_package',
    MESSAGE.CREATE_SERVICEPACKAGE_SUCCESS,
    'Tạo mới gói dịch vụ thất bại'
)

export const updateServicePackage = AxiosAdapter.HttpUpdateById(
  'servicePackageSlice/updateServicePackage',
  '/service_package',
  MESSAGE.UPDATE_SERVICEPACKAGE_SUCCESS,
  'Cập nhật gói dịch vụ thất bại'
)

export const deleteVehicleType = AxiosAdapter.HttpDelete(
    'vehicleTypeSlice/deleteVehicleType',
    'vehicle_type',
    MESSAGE.DELETE_SERVICEPACKAGE_SUCCESS,
    'Xóa gói dịch vụ thất bại'
)

export const deleteMultiServicePackage = AxiosAdapter.HttpDeleteMulti(
    'servicePackageSlice/deleteMultiServicePackage',
    'service_package',
    MESSAGE.DELETE_SERVICEPACKAGE_SUCCESS,
    'Xóa gói dịch vụ thất bại'
)

export const vehicleTypeSlice = createSlice({
  name: 'servicePackageSlice',
  initialState: {
    listServicePackages: null,
    total: 0,
    error: null,
    statusGet: null,
    statusDelete: null, 
    statusMultiDelete: null, 
    statusCreate: null,
    statusUpdate: null,
    isLoading: false, 
  },

  reducers: {
    resetChange: state => {
      state.statusGet = null;
      state.isLoading = false;
      state.statusCreate = null;
      state.statusDelete = null;
      state.statusMultiDelete = null;
      state.statusUpdate = null;
    }
  },
  extraReducers: {
    [getListServicePackages.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListServicePackages.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listServicePackages = action.payload.payload.servicePackage;
      state.total = action.payload.payload.total;
      state.isLoading = false;

    },
    [getListServicePackages.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },

    [createServicePackage.pending]: state => {
        state.statusCreate = STATUS_API.PENDING;
    },
    [createServicePackage.fulfilled]: (state, action) => {

        state.statusCreate = STATUS_API.SUCCESS;
    },
    [createServicePackage.rejected]: (state, action) => {
        state.statusCreate = STATUS_API.ERROR;
        state.errors = action.payload?.message;
    },
    [deleteVehicleType.pending]: state => {
        state.statusDelete = STATUS_API.PENDING;
    },
    [deleteVehicleType.fulfilled]: (state, action) => {
        state.statusDelete = STATUS_API.SUCCESS;
    },
    [deleteVehicleType.rejected]: (state, action) => {
        state.statusDelete = STATUS_API.ERROR;
        state.errors = action.payload.message;
    },
    [deleteMultiServicePackage.pending]: state => {
        state.statusMultiDelete = STATUS_API.PENDING;
    },
    [deleteMultiServicePackage.fulfilled]: (state, action) => {
        state.statusMultiDelete = STATUS_API.SUCCESS;
    },
    [deleteMultiServicePackage.rejected]: (state, action) => {
        state.statusMultiDelete = STATUS_API.ERROR;
        state.errors = action.payload.message;
    },
    [updateServicePackage.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateServicePackage.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateServicePackage.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.errors = action.payload.message;
    }
  }
});
export const {
  resetChange,
} = vehicleTypeSlice.actions;

export default vehicleTypeSlice.reducer;
